import * as Constants from '../constants/Constants';
import * as CookieUtils from '../CookieUtils/CookieUtils';
import { string } from '../../localization';
import { isLaptopsApp } from './SignageHelperFunctions';
import {
  checkIfCanvasApp,
  checkIfStickersTypeApp
} from '../../redux/homeActions';

export const isModelPage = page =>
  page == Constants.PRODUCT_GROUP_PAGE ||
  page == Constants.PRODUCT_LIST_PAGE ||
  page == Constants.SIZE_SELECTION_PAGE;

export const isSignageSizeSelectionPage = (selectedProduct, page) =>
  isSignageSuiteProduct() &&
  selectedProduct &&
  selectedProduct.constraintType == Constants.CONSTRAINT_TYPE_CUSTOM &&
  page == Constants.SIZE_SELECTION_PAGE;

export const isSignageProductSelectionPage = (selectedProduct, page) =>
  isSignageSuiteProduct() &&
  selectedProduct &&
  selectedProduct.constraintType == Constants.CONSTRAINT_TYPE_PDF &&
  page == Constants.PRODUCT_LIST_PAGE;

export const convertFromCamelCase = inText =>
  inText.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();

export const convertFromImperialToMetric = value =>
  value * Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;

export const convertFromMetricToImperial = value =>
  value / Constants.INCHES_TO_CENTIMETERS_CONVERSION_KEY;

export const convertFromCmToMeter = value =>
  value / Constants.METER_TO_CENTIMETERS_CONVERSION_KEY;

export const getArea = (width, height, unitSystem) => {
  if (unitSystem === Constants.METRIC_KEY) {
    return getAreaInSquareMeter(width, height);
  }
  return getAreaInSquareFeet(width, height);
};

export const getAreaInSquareMeter = (width, height) =>
  (
    (parseFloat(convertFromImperialToMetric(width).toFixed(2)) *
      parseFloat(convertFromImperialToMetric(height).toFixed(2))) /
    Constants.SQ_CENTIMETER_TO_SQ_METER
  ).toFixed(2);

export const getAreaInSquareFeet = (width, height) =>
  ((width * height) / Constants.SQ_INCHES_TO_SQ_FEET).toFixed(2);

export const getAreaUnit = unitSystem => {
  if (unitSystem === Constants.METRIC_KEY) {
    return string.SQM_UNIT_STRING_KEY;
  }
  return string.SQFT_UNIT_STRING_KEY;
};

export const convertImperialToGivenUnitSystem = (val, unitSystem) => {
  if (unitSystem === Constants.METRIC_KEY) {
    return parseFloat(convertFromImperialToMetric(val).toFixed(2));
  }
  return val;
};

export const getURLExtension = urlString =>
  urlString.split('.').pop().split(/\#|\?/)[0];

export const isSignageSuiteProduct = () => {
  const url = window.location.origin;
  if (url.search('wraps') !== -1) {
    return true;
  }
  return false;
};

export const isCanvasAppFromURL = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('sku') && queryDict.get('sku').toUpperCase() == 'WA_CA';
};

export const isWindowGraphicsAppFromURL = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('sku') == 'WGR';
};

export const getURLQueryStringAsDictionary = () =>
  new URLSearchParams(window.location.search);

export const hasRip = storeId => CookieUtils.getPrinitingOptionKey(storeId);

export const openLinkInNewTab = url => {
  window.open(url, '_blank');
};

export const openLinkInCurrentTab = url => {
  window.open(url, '_self');
};

export const isProjectDirty = fabricCanvasReducer =>
  fabricCanvasReducer.undoInstance.hasUndo() ||
  fabricCanvasReducer.makeProjectDirtyWithNoUndoSupport;

const isPremiumContent = placing => {
  if (
    placing.imageSource === Constants.VECTEEZY_TYPE ||
    placing.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE ||
    placing.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE ||
    placing.imageSource === Constants.GETTY_IMAGE_SOURCE ||
    placing.imageSource === Constants.I_STOCK_IMAGE_SOURCE ||
    placing.imageSource === Constants.ADOBE_STOCK_IMAGE_SOURCE
  ) {
    return true;
  }
  return false;
};

export const getOnlyInstagramPlacings = placings =>
  placings.filter(
    placing => placing.imageSource == Constants.INSTAGRAM_IMAGE_SOURCE
  );

export const getOnlyDreamstimePlacings = placings => {
  placings.filter(
    placing => placing.imageSource == Constants.DREAMSTIME_IMAGE_SOURCE
  );
};

export const getPremiumContentList = placings => {
  if (placings) {
    return placings.filter(placing => isPremiumContent(placing));
  }
  return [];
};

export const getUniquePremiumContent = placings => {
  const premiumList = getPremiumContentList(placings);
  return Array.from(new Set(premiumList.map(a => a.placeable.id))).map(id =>
    premiumList.find(a => a.placeable.id === id)
  );
};

export const getPremiumContentPrice = (
  premiumContentList,
  conversionUnitEUR,
  conversionUnitUSD
) =>
  premiumContentList.reduce((prev, cur) => {
    if (cur.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
      if (cur.placeable.costCurrency === Constants.USD) {
        return prev + cur.placeable.costValue * conversionUnitUSD;
      }
      if (cur.placeable.costCurrency === Constants.EUR) {
        return prev + cur.placeable.costValue * conversionUnitEUR;
      }
    } else if (
      cur.imageSource === Constants.VECTEEZY_IMAGE_SOURCE ||
      cur.imageSource === Constants.GETTY_IMAGE_SOURCE ||
      cur.imageSource === Constants.I_STOCK_IMAGE_SOURCE ||
      cur.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE ||
      cur.imageSource === Constants.ADOBE_STOCK_IMAGE_SOURCE
    ) {
      return prev + cur.placeable.costValue * conversionUnitUSD;
    }

    return null;
  }, 0);

export const uniqueArray = arrArg =>
  arrArg.filter((elem, pos, arr) => arr.indexOf(elem) == pos);

export const currencyConversion = (
  placeable,
  conversionUnitEUR,
  conversionUnitUSD
) => {
  if (
    placeable.imageSource === Constants.VECTEEZY_IMAGE_SOURCE ||
    placeable.imageSource === Constants.GETTY_IMAGE_SOURCE ||
    placeable.imageSource === Constants.I_STOCK_IMAGE_SOURCE ||
    placeable.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE ||
    placeable.imageSource === Constants.ADOBE_STOCK_IMAGE_SOURCE
  ) {
    return placeable.costValue * conversionUnitUSD;
  }
  if (placeable.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
    if (placeable.costCurrency === Constants.USD) {
      return placeable.costValue * conversionUnitUSD;
    }
    if (placeable.costCurrency === Constants.EUR) {
      return placeable.costValue * conversionUnitEUR;
    }
  }
  return '';
};

export const getArrayOfEachPremiumContent = (placings, type) => {
  if (placings) {
    return placings.filter(placing => placing.imageSource == type);
  }
  return [];
};

export const getDefaultProjectName = category => (dispatch, getState) => {
  const { multiWallProjects } = getState().finalCheck;
  if (getState().modal.envData.project_name) {
    return getState().modal.envData.project_name;
  }
  switch (category) {
    case Constants.NEW_POSTER_CATEGORY:
    case Constants.POSTER_CATEGORY:
      return string.PLACEHOLDER_PROJECT_NAME;
    case Constants.GIFTWRAPS_CATEGORY:
      return string.MY_GIFTWRAPS_KEY;
    case Constants.CANVAS_CATEGORY:
      return 'Canvas';
    case Constants.WALLPAPER_CATEGORY:
      if (getState().modal.envData.wallart_lite_web_link) {
        return getDefaultProjectNameWithTimeStamp();
      }
      return multiWallProjects.length >= 1
        ? `Wallcovering_${multiWallProjects.length}`
        : 'Wallcovering';
    default:
      return (
        getState().home.selectedProduct &&
        `${getState().home.selectedProduct.name}`
      );
  }
};

export const getDefaultProjectNameWithTimeStamp = () => {
  const defaultName = string.DEFAULT_PROJECT_NAME;
  const date = new Date();
  return `${defaultName} ${date.getFullYear().toString()}-${(
    date.getMonth() + 1
  ).toString()}-${date
    .getDate()
    .toString()} ${date
    .getHours()
    .toString()}:${date
    .getMinutes()
    .toString()}:${date.getSeconds().toString()}`;
};

export const isHostedContent = theme =>
  theme.hostedContentThemeId || theme.hostedContent;

export const isLaunchToProcessingPageEnabled = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('request_print');
};

export const isLaunchToCheckoutEnabled = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('checkout');
};

export const isWallartLiteWebLinkEdit = () => {
  const queryDict = getURLQueryStringAsDictionary();
  if (queryDict.get('project_token') && queryDict.get('edit_weblink_project')) {
    return true;
  }
  return false;
};

export const canEditProject = () => {
  const queryDict = getURLQueryStringAsDictionary();

  if (queryDict.get('project_id')) {
    return true;
  }
  return false;
};

export const isEditLink = () => {
  const queryDict = getURLQueryStringAsDictionary();
  if (queryDict.get('project_token') || queryDict.get('project_id')) {
    return true;
  }
  return false;
};

export const getUserId = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('user_id');
};

export const retailerPosCode = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('pos_code');
};

export const retailerEmployeeCode = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('employee_code');
};

export const getCostCurrency = placeable => {
  if (
    placeable.imageSource === Constants.VECTEEZY_IMAGE_SOURCE ||
    placeable.imageSource === Constants.GETTY_IMAGE_SOURCE ||
    placeable.imageSource === Constants.I_STOCK_IMAGE_SOURCE ||
    placeable.imageSource === Constants.DREAMSTIME_IMAGE_SOURCE ||
    placeable.imageSource === Constants.ADOBE_STOCK_IMAGE_SOURCE
  ) {
    return '$';
  }
  if (placeable.imageSource === Constants.PATTERN_DESIGN_IMAGE_SOURCE) {
    return placeable.costCurrency;
  }
  return '';
};

export const isARCEnabled = (projectCategory, partnerStoreType) =>
  partnerStoreType === Constants.PARTNER_STORE_ARC &&
  projectCategory === Constants.GIFTWRAPS_CATEGORY;

export const orientationSupportedProducts = category => {
  if (category === Constants.NEW_POSTER_CATEGORY) {
    return true;
  }
  return false;
};

export const shouldSelectFirstSceneOfFirstTheme = () => (dispatch, getState) =>
  getState().modal.storeData.launchWithBackground &&
  getState().modal.envData.wallart_lite_web_link &&
  dispatch(checkIfStickersTypeApp());

export const isPremiumTheme = theme =>
  /_pattern_design/.test(theme.internalName) ||
  /_vecteezy/.test(theme.internalName) ||
  /_unsplash/.test(theme.internalName) ||
  /_dreamstime/.test(theme.internalName) ||
  /_getty_images/.test(theme.internalName) ||
  /_istock/.test(theme.internalName) ||
  /_adobe_stock/.test(theme.internalName) ||
  /_hp_mosaic/.test(theme.internalName) ||
  (Object.prototype.hasOwnProperty.call(theme, 'isPremium') && theme.isPremium);

export const shouldSelectTabFromUrl = () => {
  const queryDict = getURLQueryStringAsDictionary();
  return queryDict.get('content_tab');
};

export const checkForPosterVersion = () => (dispatch, getState) => {
  if (
    getState().modal.envData.category === Constants.NEW_POSTER_CATEGORY ||
    getState().modal.envData.category === Constants.POSTER_CATEGORY
  ) {
    if (getState().modal.envData.is_vanilla_designer) {
      return 'LiteVersion';
    }
    return 'FullVersion';
  }
  return '';
};

export const getDate = () => {
  const date = new Date();
  return `${date.getFullYear().toString()}-${(
    date.getMonth() + 1
  ).toString()}-${date.getDate().toString()}`;
};

export const getCookieActivityNameForWeblink = identifier => {
  if (identifier === Constants.DESIGN_KEY) {
    return Constants.WEBLINK_SAVE_ACTIVITY;
  }
  return Constants.WEBLINK_CHECKOUT_ACTIVITY;
};

export const getCookieActivityNameForLitePatner = identifier => {
  if (identifier === Constants.DESIGN_KEY) {
    return Constants.LITE_SAVE_ACTIVITY;
  }
  return Constants.LITE_CHECKOUT_ACTIVITY;
};

export const isGroupSettingsSupportedApp = gsku =>
  isLaptopsApp(gsku) || isMaskApp(gsku);

export const checkIfLaptopAppBeforeProductSelection = () => (
  dispatch,
  getState
) => {
  const { gsku } = getState().modal.sessionData;
  if (gsku) {
    return isLaptopsApp(gsku);
  }
  const product = getState().modal.storeData.supportedProducts[0];
  return isLaptopsApp(product.groupType);
};

export const checkIfMaskAppBeforeProductSelection = () => (
  dispatch,
  getState
) => {
  const { gsku } = getState().modal.sessionData;
  if (gsku) {
    return isMaskApp(gsku);
  }
  const product = getState().modal.storeData.supportedProducts[0];
  return isMaskApp(product.groupType);
};

export const isTransparentModel = groupType => {
  if (groupType == 'PRTS') {
    return true;
  }
  return false;
};

export const isPremiumApp = envData => {
  if (envData) return envData.is_premium_app;
  return true;
};

export const isMaskApp = groupType => {
  if (groupType == 'MASK') {
    return true;
  }
  return false;
};

export const isPresoniseApp = groupType => {
  if (isLaptopsApp(groupType)) {
    return true;
  }
  return false;
};

export const getProductWithName = () => (dispatch, getState) => {
  const { supportedProducts } = getState().modal.storeData;
  const { category } = getState().modal.envData;
  const projectCategory = getState().finalCheck.project.category;
  const { sku } = getState().modal.sessionData;
  for (let i = 0; i < supportedProducts.length; i++) {
    const product = supportedProducts[i];
    if (
      category == product.category ||
      projectCategory == product.category ||
      sku == product.sku
    ) {
      return product;
    }
  }

  return null;
};

export const checkForPage = page => {
  if (page === Constants.DESIGN_PAGE) {
    return Constants.DESIGN_KEY;
  }
  if (page === Constants.FINAL_CHECK_PAGE) {
    return Constants.GA_EVENET_LABEL.REVIEW_ORDER;
  }
  if (page === Constants.FILE_PROCESSING_PAGE) {
    return Constants.GA_EVENET_LABEL.FILE_PROCESSING;
  }
  if (page === Constants.DESIGN_SHARE_PAGE) {
    return Constants.GA_EVENET_LABEL.DESIGN_SHARE_PAGE;
  }
  return '';
};

export const getCategoryOfProduct = () => (dispatch, getState) => {
  if (isSignageSuiteProduct()) {
    const { gsku } = getState().modal.sessionData;
    if (gsku) {
      return gsku;
    }
    const product = getState().modal.storeData.supportedProducts[0];
    return product.groupType;
  }
  return getState().modal.envData.category;
};

export const isStartUpScene = scenePlacing => (dispatch, getState) => {
  const { startUpScene } = getState().modal;
  if (startUpScene) {
    return scenePlacing.placeableId == startUpScene.id;
  }
  return false;
};

export const isBlockchainTransactionEnabled = () => (dispatch, getState) =>
  getState().modal.envData.is_blockchain_transaction_enabled;

export const checkForMultilineText = text => {
  let eachLine = [];
  let tmp = 0;
  if (text) {
    eachLine = text.split('\n');
  }
  if (eachLine.length) {
    for (let i = 0; i < eachLine.length; i++) {
      if (eachLine[i] != '') {
        tmp++;
      }
    }
    if (tmp > 1) {
      return true;
    }
    return false;
  }
  return false;
};

export const isLockedProject = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  return (
    project.state != Constants.EDITING_STATE &&
    project.state != Constants.PRO_DESIGN_STATE &&
    project.state != Constants.INSPIRATION_STATE &&
    project.state != Constants.TEMPLATE_STATE &&
    !getState().modal.envData.view_only_preview_mode &&
    !getState().modal.envData.wallart_lite_web_link_edit
  );
};

export const isExpiredProject = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  return project.state == Constants.EXPITED_STATE;
};

export const isDeletedProject = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  return (
    project.state == Constants.SOFT_DELETED_STATE ||
    getState().modal.storeData.eCommerceSiteDeleted
  );
};

export const isNonEditableInspiration = () => (dispatch, getState) =>
  getState().finalCheck.project.locked;

export const isMultiCanvas = () => (dispatch, getState) =>
  getState().home.canvasType == Constants.MULTI_CANVAS;

export const isRoomMode = () => (dispatch, getState) => {
  const { viewType } = getState().fabricCanvas;
  return dispatch(checkIfCanvasApp()) && viewType == Constants.THREE_D_TYPE;
};

export const isStickerWorkspaceMode = () => (dispatch, getState) => {
  const { viewType } = getState().fabricCanvas;
  return (
    dispatch(checkIfStickersTypeApp()) &&
    viewType == Constants.EDIT_WORKSPACE_TYPE
  );
};

export const isStickerPreviewMode = () => (dispatch, getState) => {
  const { viewType } = getState().fabricCanvas;
  return (
    dispatch(checkIfStickersTypeApp()) &&
    viewType &&
    viewType != Constants.EDIT_WORKSPACE_TYPE
  );
};

export const getActiveCanvas = placing => (dispatch, getState) => {
  const { wallCanvas, roomCanvas } = getState().fabricCanvas;
  if (
    placing &&
    placing.placeableType == Constants.WALL_LAYOUT_KEY &&
    dispatch(isRoomMode())
  ) {
    return roomCanvas;
  }
  if (!placing && dispatch(isRoomMode())) {
    return roomCanvas;
  }
  return wallCanvas;
};

export const isToolbarItemDisabled = itemId => (dispatch, getState) => {
  const { filteredTools } = getState().fabricCanvas;
  const toolItem = filteredTools.find(item => item.id == itemId);
  return toolItem && toolItem.state === Constants.DISABLED_STATE;
};

const findIndex = (arr, val) => {
  let low = 0;
  let high = arr.length;
  while (low < high) {
    const mid = (low + high) >>> 1;
    if (arr[mid] < val) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return low;
};

export const insertAt = (arr = [], num) => {
  const position = findIndex(arr, num);
  arr.splice(position, 0, num);
};

export const isTextElement = object =>
  object && object.placing.placeableType === Constants.TEXT_ELEMENT_TYPE;
